<template>
  <div class="about">
    <AboutHeader />
    <AboutTech />
    <AboutService />
    <AboutTrusted />
    <AboutTeam />
    <AboutCallAction />
  </div>
</template>

<script>
import { useMeta } from "vue-meta";
import AboutHeader from "@/components/about/AboutHeader.vue";
import AboutTech from "@/components/about/AboutTech.vue";
import AboutService from "@/components/about/AboutService.vue";
import AboutTrusted from "@/components/about/AboutTrusted";
import AboutTeam from "@/components/about/AboutTeam.vue";
import AboutCallAction from "@/components/about/AboutCallAction.vue";
export default {
  mounted() {
    import("@/assets/globalJs/global.js").then((module) => {
      const { observeElements } = module;
      observeElements(
        ".slide-right",
        ".slide-left",
        ".fall-down",
        ".image-fade-in"
      );
    });
  },
  components: {
    AboutHeader,
    AboutTech,
    AboutService,
    AboutTrusted,
    AboutTeam,
    AboutCallAction,
  },
  setup() {
    useMeta({
      title: "Révolutionner la Formation des Salariés",
      description: [
        {
          content:
            "YouCanLearn, une marque d’IMPROVISACTION, transforme la formation des salariés en intégrant le micro learning. Améliorez la qvt au travail grâce à des contenus adaptés à chaque poste pour une formation entreprise efficace.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.youcanlearn.fr/about",
        },
      ],
    });
  },
};
</script>
